import Swal from "sweetalert2";
import { jwtDecode } from "jwt-decode";

const isTokenValid = (token,navigate) => {
  try {
    const { exp } = jwtDecode(token);
    if (!exp) return false;
    const currentTime = Date.now() / 1000;
    return currentTime < exp;
  } catch (error) {
    console.error("Invalid token:", error);
    localStorage.clear();
    navigate("/");
  }
};

export const checkTokenAndNavigate = async (fetchLocations, tryRefresh, navigate) => {
  const accessToken = localStorage.getItem("digital-form-accesstoken");
  const idToken = localStorage.getItem("digital-form-idtoken");
  const userDetails = localStorage.getItem("digital-form-user_details");
  const refresh_token = localStorage.getItem("digital-form-refresh_token");
  const dept_id = localStorage.getItem("digital-form-dept-id");
  const practice = localStorage.getItem("digital-form-dept-practice");

  if (accessToken && idToken && userDetails && refresh_token && practice && dept_id) {
    const isAccessValid = isTokenValid(accessToken,navigate);

    if (isAccessValid) {
      fetchLocations();
    }
    else {
      await Swal.fire({
        icon: "warning",
        title: "Session Expired",
        text: "Your session has expired. Please click on Restore Session to continue",
        confirmButtonText: "Restore Session",
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          await tryRefresh(true); // trigger refresh logic
        }
      });
    }

  }
  else {
    console.warn("Required auth info missing.");
    localStorage.clear();
    navigate("/");
  }

};
